var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDownloadArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10303_10355",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10303_10355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.25 13.9122L6.12312 9.7853L7.14182 8.73685L9.52502 11.1201V3H10.975V11.1201L13.3582 8.73685L14.3769 9.7853L10.25 13.9122ZM4.74745 17.5C4.25915 17.5 3.84584 17.3308 3.5075 16.9925C3.16917 16.6542 3 16.2408 3 15.7526V13.1314H4.44998V15.7526C4.44998 15.8269 4.48096 15.8951 4.54293 15.9571C4.60491 16.019 4.67308 16.05 4.74745 16.05H15.7525C15.8269 16.05 15.8951 16.019 15.9571 15.9571C16.019 15.8951 16.05 15.8269 16.05 15.7526V13.1314H17.5V15.7526C17.5 16.2408 17.3308 16.6542 16.9925 16.9925C16.6542 17.3308 16.2408 17.5 15.7525 17.5H4.74745Z",
    fill: "#757575"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDownloadArrow);
export default __webpack_public_path__ + "static/media/ic-download-arrow.0504efcbd585b13f47bb8f814d099450.svg";
export { ForwardRef as ReactComponent };